import { Box, styled } from '@mui/material';
import IcErrorCircleRegular from '@kep/kcds-icons/IcErrorCircleRegular';
import IcSuccessCircleRegular from '@kep/kcds-icons/IcSuccessCircleRegular';
import IcWarningTriangleRegular from '@kep/kcds-icons/IcWarningTriangleRegular';

import type { ToastIconsMap } from './types';

const ToastIconWrapper = styled(Box)(
  () => `
  font-size: 20px;
  width: 20px;
  height: 20px;
  margin-right: 8px;
`,
);

const ToastIcons: ToastIconsMap = {
  success: (
    <ToastIconWrapper>
      <IcSuccessCircleRegular />
    </ToastIconWrapper>
  ),
  info: (
    <ToastIconWrapper>
      <IcErrorCircleRegular />
    </ToastIconWrapper>
  ),
  error: (
    <ToastIconWrapper>
      <IcWarningTriangleRegular />
    </ToastIconWrapper>
  ),
};

export default ToastIcons;
